// extracted by mini-css-extract-plugin
export var checkbox = "ContactForm-module--checkbox--xd4QQ";
export var close = "ContactForm-module--close--rCA2u";
export var close_icon = "ContactForm-module--close_icon--RVbc8";
export var container = "ContactForm-module--container--X1Nu-";
export var form = "ContactForm-module--form--6fhOz";
export var form_wrapper = "ContactForm-module--form_wrapper--DVnXh";
export var header = "ContactForm-module--header--dKzOJ";
export var mask = "ContactForm-module--mask--c3qc7";
export var require_mark = "ContactForm-module--require_mark--kEVbG";
export var select = "ContactForm-module--select--xT-DD";
export var submit = "ContactForm-module--submit--mChuL";